import { render, staticRenderFns } from "./RoleAddEditStep2.vue?vue&type=template&id=59ae0dd4&scoped=true"
import script from "./RoleAddEditStep2.vue?vue&type=script&lang=js"
export * from "./RoleAddEditStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae0dd4",
  null
  
)

export default component.exports